
  import React from "react"
  import Component from "/Users/fabianbrenes/squidsource/src/layouts/es.js"
  import data from "/Users/fabianbrenes/squidsource/.cache/json/layout-es.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/es.js